/**
 * @generated SignedSource<<3581ad0bdce1cc438b43c12b884d24cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useCurrentClientMembershipTypeId_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly membershipType: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useCurrentClientMembershipTypeId_session";
};
export type useCurrentClientMembershipTypeId_session$key = {
  readonly " $data"?: useCurrentClientMembershipTypeId_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCurrentClientMembershipTypeId_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useCurrentClientMembershipTypeId_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "membershipType",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "a734159a02ed0675ad0cca8f13c4bcda";

export default node;
